import { gql } from '@apollo/client'
import { useProjectId } from '@btime/react-session'
import React from 'react'

import { integrationsClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useIntegrationsState = () => React.useContext(Context) || {}
export const useIntegrations = () => useIntegrationsState()?.integrations || []

const QUERY = gql`
  query Integrations($page: Int, $sort: IntegrationSort, $filter: IntegrationFilter) {
    integrations(page: $page, sort: $sort, filter: $filter) {
      id
      name
      createdBy {
        id
        name
      }
    }
  }
`

const IntegrationsLoader = ({ children, uncontrolledChildren }) => {
  const { service } = useModalData()
  const currentProjectId = useProjectId()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      sort: { field: 'NAME', type: 'ASC' },
      filter: { projectId: currentProjectId, services: service }
    },
    client: integrationsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default IntegrationsLoader
